export const toSaveCommand = (formValues) => ({
  ...formValues,
  emails: formValues.emails.split(',').map((email) => email.trim()),
});

export const toFormValues = (owner) => ({
  ...owner,
  emails: owner.emails.join(', '),
});
